import { render } from "./googlefit.vue?vue&type=template&id=50447935"
import script from "./googlefitjs.js?vue&type=script&lang=js"
export * from "./googlefitjs.js?vue&type=script&lang=js"

import "./googlefit.vue?vue&type=style&index=0&id=50447935&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__